
export function redirectTo(path){
  window.location = path
}
